/**
 * Shared i18n Resources
 * Exports all shared translation resources
 */

// English resources
import commonEn from './en/common.json';
import validationEn from './en/validation.json';
import errorsEn from './en/errors.json';
import authEn from './en/auth.json';

// Hebrew resources
import commonHe from './he/common.json';
import validationHe from './he/validation.json';
import errorsHe from './he/errors.json';
import authHe from './he/auth.json';

export const sharedResources = {
  en: {
    common: commonEn,
    validation: validationEn,
    errors: errorsEn,
    auth: authEn,
  },
  he: {
    common: commonHe,
    validation: validationHe,
    errors: errorsHe,
    auth: authHe,
  },
};

export default sharedResources;
